module.exports = __webpack_public_path__ + "static/media/trolleybus.b8e213b8.svg";